export default __webpack_public_path__ + "static/media/discretion.315dcb21.png";